/* PWA glue: service worker registration + update detection + install prompt capture */
let registration = null;
let deferredInstallPrompt = null;

export const isStandalone = () =>
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

export const getInstallPrompt = () => deferredInstallPrompt;

export function clearInstallPrompt() {
    deferredInstallPrompt = null;
    window.dispatchEvent(new Event("pwa-install-changed"));
}

export function getWaitingWorker() {
    return registration?.waiting || null;
}

export function applyUpdate() {
    const waiting = registration?.waiting;
    if (!waiting) { window.location.reload(); return; }
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
    });
    waiting.postMessage({ type: "SKIP_WAITING" });
}

export function initPwa() {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredInstallPrompt = e;
        window.dispatchEvent(new Event("pwa-install-changed"));
    });
    window.addEventListener("appinstalled", () => clearInstallPrompt());

    if (!("serviceWorker" in navigator)) return;
    window.addEventListener("load", async () => {
        try {
            registration = await navigator.serviceWorker.register("/sw.js");
        } catch { return; }
        const announce = () => window.dispatchEvent(new Event("pwa-update-available"));
        if (registration.waiting && navigator.serviceWorker.controller) announce();
        registration.addEventListener("updatefound", () => {
            const nw = registration.installing;
            if (!nw) return;
            nw.addEventListener("statechange", () => {
                if (nw.state === "installed" && navigator.serviceWorker.controller) announce();
            });
        });
        const check = () => registration.update().catch(() => {});
        setInterval(check, 60 * 60 * 1000);
        document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
    });
}
